const getSort = ({ sortBy, sortDirection }) => (
  `${sortDirection === 'desc' ? '-' : ''}${sortBy}`
);

export default getSort;
